<template>
  <div class="modals-container">
    <VModal v-if="!userState.user && authError" v-model:showing="authError" :hide-close="hideCloseBtn">
      <div class="flex flex-col my-4">
        <div class="text-xl">{{ authErrorMessage }}.</div>
        <div class="button-actions mt-8 w-full">
          <VButton class="w-full text-center my-2" variant="copper" @click="goToLoginPage">Log In</VButton>
          <VButton v-if="!hideCloseBtn" class="w-full my-2" @click="authError = false">Dismiss</VButton>
        </div>
      </div>
    </VModal>
    <VModal v-if="permissionsError" v-model:showing="permissionsError" :hide-close="hideCloseBtn">
      <div class="flex flex-col my-4">
        <p class="text-xl">You do not have access to this {{ content }}.</p>
        <VButton class="w-full text-center mt-8" variant="copper" component="a" href="/">Okay</VButton>
      </div>
    </VModal>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  // TODO: this needs a better name
  project: {
    type: String,
    required: false,
    default: 'project',
  },

  content: {
    type: String,
    required: false,
    default: 'content',
  },

  showLogin: {
    type: Boolean,
    required: false,
    default: false,
  },

  showSignUp: {
    type: Boolean,
    required: false,
    default: false,
  },

  hasAuthError: {
    type: Boolean,
    required: false,
    default: false,
  },

  hasPermissionsError: {
    type: Boolean,
    required: false,
    default: false,
  },

  shouldRefresh: {
    type: Boolean,
    default: true,
  },

  authErrorCopy: {
    type: String,
    required: false,
    default: '',
  },
  hideClose: {
    type: Boolean,
    default: false,
  },
})

const route = useRoute()

const permissionsError = ref(false)
const authError = ref(false)
const { state: userState } = useUser()

const emit = defineEmits(['update:hasAuthError'])

const shouldHideClose = computed(() => {
  return permissionsError.value || !userState.value.user
})

const hideCloseBtn = computed(() => {
  return props.hideClose && shouldHideClose.value
})

const authErrorMessage = computed(() => {
  if (props.authErrorCopy && props.authErrorCopy.length > 0) {
    return props.authErrorCopy
  } else {
    return `Please log in to access ${props.project}`
  }
})

watch(
  () => authError.value,
  val => {
    emit('update:hasAuthError', val)
  }
)

watch(
  () => props.showLogin,
  async val => {
    if (val) {
      await navigateTo({ name: 'login', query: { ...route.query, redirectedFrom: route.path } })
    }
  }
)

watch(
  () => props.showSignUp,
  async val => {
    if (val) {
      await navigateTo({ name: 'signup', query: { ...route.query, redirectedFrom: route.path } })
    }
  }
)

watch(
  () => props.hasAuthError,
  val => {
    authError.value = val
  },
  { immediate: true }
)

watch(
  () => props.hasPermissionsError,
  val => {
    permissionsError.value = val
  },
  { immediate: true }
)

const goToLoginPage = async () => {
  await navigateTo({ name: 'login', query: { ...route.query, redirectedFrom: route.path } })
}
</script>

<style lang="stylus" scoped>
.modals-container
  z-index: 9000
  position: fixed
</style>
